import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotValue = (formData.get('website_alt') as string || '').trim();
    if (honeypotValue) {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    setStatus('loading');
    setMessage('');

    try {
      const body = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'website_alt') {
          body.append(key, value.toString());
        }
      });

      const response = await fetch('https://readdy.ai/api/form/d9othfqqs38sj6jc7fj0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注，您将第一时间收到韩漫更新提醒。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setStatus('error');
          setMessage('提交失败，请稍后再试。');
        } else {
          setStatus('error');
          setMessage(serverMsg || '订阅失败，请稍后重试。');
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络连接后重试。');
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-900 text-foreground-100">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-50 mb-4">
          订阅韩漫更新提醒
        </h2>
        <p className="text-foreground-300 mb-8 leading-relaxed">
          第一时间获取最新韩漫更新通知，不错过任何精彩内容
        </p>
        <form
          className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto"
          data-readdy-form="true"
          onSubmit={handleSubmit}
        >
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="honeypot-field"
          />
          <input
            type="email"
            name="email"
            placeholder="请输入您的邮箱地址"
            className="flex-1 px-5 py-3 rounded-full bg-background-800 border border-background-700 text-foreground-100 placeholder:text-foreground-500 text-sm focus:outline-none focus:border-primary-500 transition-colors"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-8 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 font-medium text-sm transition-colors whitespace-nowrap disabled:opacity-60"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
        </form>
        {message && (
          <p className={`mt-4 text-sm ${status === 'success' ? 'text-accent-400' : 'text-red-400'}`}>
            {message}
          </p>
        )}
        <p className="mt-4 text-xs text-foreground-500">
          我们尊重您的隐私，绝不会分享您的邮箱地址
        </p>
      </div>
    </section>
  );
}